import React from "react";
import ConfidenceLabel from "../../shared/ConfidenceLabel";

const TabDateRecul = ({ form, onChange, getConfidence }) => {
  const gc = getConfidence || (() => ({ exists: false }));
  return (
    <div className="dn-fields">
      <div className="dn-field-group">
        <label>Date <ConfidenceLabel confidence={gc("date")} /></label>
        <input type="date" value={form.date ?? ""}
          onChange={(e) => onChange("date", e.target.value)}
          style={{ borderColor: gc("date").color || undefined }} />
      </div>
      <div className="dn-field-group">
        <label>Recul après la fin du TRT <ConfidenceLabel confidence={gc("recul_fin_trt")} /></label>
        <input type="text" placeholder="Ex : 6 mois, 1 an..."
          value={form.recul_fin_trt ?? ""}
          onChange={(e) => onChange("recul_fin_trt", e.target.value)}
          style={{ borderColor: gc("recul_fin_trt").color || undefined }} />
      </div>
      <div className="dn-field-group">
        <label>Niveau d'étude <ConfidenceLabel confidence={gc("niveau_etude")} /></label>
        <input type="text" placeholder="Ex : CM2, 3ème, Terminale..."
          value={form.niveau_etude ?? ""}
          onChange={(e) => onChange("niveau_etude", e.target.value)}
          style={{ borderColor: gc("niveau_etude").color || undefined }} />
      </div>
    </div>
  );
};

export default TabDateRecul;